module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"noIntegrations":"Для вашего региона нет доступных интеграций"}}')
  delete Component.options._Ctor
}
